import type { GatewaySettingsFormErrors } from '../interfaces/gatewaySettingsFormErrors.interface'

export function hasGatewaySettingsFormErrors(errors: GatewaySettingsFormErrors): boolean {
  return Object.values(errors).some(Boolean)
}
